import React from "react";

import destination_1 from "../../public/wheretogo-jeseniky/karlovastudanka/destination_1.png";
import destination_2 from "../../public/wheretogo-jeseniky/karlovastudanka/destination_2.png";
import destination_3 from "../../public/wheretogo-jeseniky/karlovastudanka/destination_3.png";
import destination_4 from "../../public/wheretogo-jeseniky/karlovastudanka/destination_4.png";
import destination_5 from "../../public/wheretogo-jeseniky/karlovastudanka/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-jeseniky/karlovastudanka/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-jeseniky/karlovastudanka/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-jeseniky/karlovastudanka/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-jeseniky/karlovastudanka/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const KarlovaStudanka = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Karlova Studánka</h1>
            <p>
              Lázeňské město zvané Karlová studánka, bylo založeno v roce 1785
              synem Marie Terezie. Pro svoji jedinečnou polohu a léčivé klima je
              Karlova Studánka ideálním místem pro léčbu pacientů s onemocněním
              dýchacích cest,vysokého krevního tlaku a onemocnění cév
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>lázně</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>příroda</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>ubytování</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>dostupnost</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Klimatické podmínky jsou na Šeráku extrémní , průměrná roční
                  teplota je 2,2 °C a je zde sněhova příkryvka 180dni v roce.
                </li>
                <li>
                  Jiřího chata byla původně jako dřevostavba vztyčena již v roce
                  1888 místním horským spolkem MSSGV a pojmenovaná po
                  arcibiskupovi Georgu Koppovi, jenž vlastnil okolní pozemky,
                  Chata byla do současné podoby rozšířena roku 1926.
                </li>
                <li>
                  Na vrchol Šeráku vede sedačková lanová dráha z Ramzové s
                  přestupní stanicí Čerňava. Od horní stanice je na vrchol
                  vzdáleny asi 250 m a nabízí překrásné výhledy především na
                  Jesenicko, Staroměstsko, Králický Sněžník a Rychlebské hory.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KarlovaStudanka;
